// Modal con las reservas de un día concreto + acciones de cancelar/leave.

import * as Dialog from '@radix-ui/react-dialog';
import { Icon } from '@/components/atoms/Icon';
import { BookingCard } from '@/components/molecules/BookingCard';
import type { BookingListItem } from '@/services/bookings';
import styles from './DayBookingsDialog.module.scss';

interface DayBookingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  day: string | null;
  bookings: BookingListItem[];
  onCancel: (id: number) => void;
  onLeave: (id: number) => void;
}

function formatDayEs(day: string): string {
  const d = new Date(`${day}T00:00:00`);
  const s = d.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function DayBookingsDialog({ open, onOpenChange, day, bookings, onCancel, onLeave }: DayBookingsDialogProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.content} aria-describedby={undefined}>
          <header className={styles.header}>
            <Dialog.Title className={styles.title}>
              {day ? formatDayEs(day) : ''}
            </Dialog.Title>
            <Dialog.Close asChild>
              <button className={styles.closeBtn} aria-label="Cerrar">
                <Icon name="x" size={20} />
              </button>
            </Dialog.Close>
          </header>
          <div className={styles.body}>
            {bookings.length === 0 ? (
              <p className={styles.muted}>No tienes reservas este día.</p>
            ) : (
              <div className={styles.list}>
                {bookings.map((b) => (
                  <BookingCard
                    key={b.id}
                    booking={b}
                    isMine={true}
                    joinedAsStudent={true}
                    onCancel={b.type === 'one' ? onCancel : undefined}
                    onLeave={b.type === 'gr' ? onLeave : undefined}
                  />
                ))}
              </div>
            )}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
